import * as React from "react";
import { PrimaryButton } from "../../../Base/Buttons";

export default ({ onSubmit, contract }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 200,
      }}
    >
      <div>
        <PrimaryButton
          title={
            contract?.pre_existing
              ? "Spara och visa avtal"
              : "Spara och gå vidare till dokument för signering"
          }
          clicked={onSubmit}
        />
      </div>
    </div>
  );
};
